<template>
  <div class="footer d-flex align-center justify-center">
    <div class="footer-content d-flex f-column justify-center align-center">
      <p>国农（重庆）生猪大数据产业发展有限公司</p>
      <div class="d-flex align-center">
        <span class="tip">渝ICP备2020011253号-1</span>
        <div class="d-flex align-center tip">
          <el-image
            class="image"
            :src="require('@/assets/images/footer_img.png')"
          ></el-image>
          <span>&nbsp;渝公网安备 50022602000341号</span>
        </div>
        <!-- <span class="tip">增值电信业务经营许可证编号：B1-0000000</span> -->
        <span class="tip"
          >Copyright © 2018-2020</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  height: 2.25rem;
  background-color: #f9fafe;
  &-content {
    font-size: 0.2rem;
    color: #999;
    p {
      margin-bottom: 0.35rem;
    }
    span {
      font-size: 0.1625rem;
    }
    .tip {
      padding: 0 0.175rem;
    }
    .image {
      width: 0.2rem;
      height: 0.2rem;
    }
  }
}
</style>
